<template>
    <div>
        <!-- Add Marketer Button -->
        <button 
            class="btn btn-dark-green btn-sm form-control" 
            @click.prevent="addMarketerFxn" 
            v-bind="{'disabled' : buttonDisabled}" 
            v-bind:class="{'disabledClass' : buttonDisabled}">
            {{buttonText}}
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { capitalizeWord } from '@/store/dry'
export default {
    name: "AddMarketerBtn",
    props: ['userId', 'buttonText', 'bankObj', 'buttonDisabled'],
    data() {
        return {
            color: 'danger',
            msg: ''
        }
    },
    methods: {
        ...mapActions(['portalLookupUser', 'addMarketer']),
        addMarketerFxn() {
            this.resetAll()
            if(!this.theLookupUser){ 
                this.msg = "Unable to proceed! Click 'Return to Search' to find a user!"; 
                this.$emit('emitMsg', this.msg);
                return 
            }
            if(!this.theLookupUser.emailConfirmed){ 
                this.msg = `${capitalizeWord(this.theLookupUser.name)} email must be verified to qualify for this role!`; 
                this.$emit('emitMsg', this.msg);
                return 
            }
            if(!this.theLookupUser.itemsCount > 0){ 
                this.msg = `${capitalizeWord(this.theLookupUser.name)} must post at least one item to qualify for this role!`;
                this.$emit('emitMsg', this.msg);
                return 
            }
            let marketerObj = {
                userId: this.theLookupUser._id,
                // //stateRepId: this.user._id, // pre-populate with my id (dynamically)
            }
            // include the bankObj if it contains value
            if(this.bankObj) {
                marketerObj = { ...marketerObj, ...this.bankObj }
            }
            this.addMarketer(marketerObj)
            .then((data) => {
                if(!data.error) {
                    this.color = 'success'
                    this.$emit('emitColor', this.color);
                }
                this.msg = data.msg
                this.$emit('emitMsg', this.msg);
            })
            .catch((e) => {})
        },
        runPortalLookupUser(theUserId) {
            let userObj = {
                userId: theUserId
            }
            this.portalLookupUser(userObj)
            .then((data) => {
                this.msg = data.msg
                if(!data.error){
                    this.color = 'success'
                    this.$emit('emitColor', this.color);
                }
                this.resetAll()
            })
            .catch((e) => {
                this.msg = 'Unable to reach portal at this time! Try again later'
                this.$emit('emitMsg', this.msg);
            })
        },
        resetAll() {
            this.color = 'danger'
            this.$emit('emitColor', this.color);
            this.msg = ''
            this.$emit('emitMsg', this.msg);
        }
    },
    computed: {
        ...mapGetters(['portalLookup']),
        theLookupUser() {
            if(this.portalLookup && this.portalLookup !== null) {
                return this.portalLookup
            }
            return false
        }
    },
    watch: {
        userId() {
            this.runPortalLookupUser(this.userId)
        },
        buttonDisabled() {
            this.buttonDisabled = this.buttonDisabled
        }
    },
    created() {
        this.resetAll()
        this.runPortalLookupUser(this.userId)
    }
}
</script>